import { Pipe, PipeTransform } from '@angular/core';
import { HangHoa, valueSearch } from '../models/product.model';
@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(products:  HangHoa[], searchText: valueSearch): HangHoa[] {
    if (!products || !searchText.value) { return products; }
    return  products.filter( it => {
      if(searchText.option === 'UPC'){
        return it.MaHH.toLowerCase().indexOf(searchText.value.toLowerCase()) !== -1; 
      } else if (searchText.option === 'SKU'){
        return it.SKU.toLowerCase().indexOf(searchText.value.toLowerCase()) !== -1;
      } else {
        return it.TenHH.toLowerCase().indexOf(searchText.value.toLowerCase()) !== -1;
      }
    });
   }
}



// WEBPACK FOOTER //
// ./src/app/pipe/filter.pipe.ts